module.exports = __webpack_public_path__ + "static/media/breaking_changes.27437a6a.jpg";